import apiService from '@/services/apiService'

const unwrap = (response) => response?.data?.data

export default {
  getUserOperationalContext() {
    return apiService.get('/api/auth/users/operational-context').then(unwrap)
  },
  listSucursales() {
    return apiService.get('/api/maintenance/operational-context/sucursales').then(unwrap)
  },
  listCajas(params = {}) {
    return apiService.get('/api/maintenance/operational-context/cajas', params).then(unwrap)
  },
  createCaja(payload) {
    return apiService.post('/api/maintenance/operational-context/cajas', payload).then(unwrap)
  },
  updateCaja(cajaId, payload) {
    return apiService.put(`/api/maintenance/operational-context/cajas/${cajaId}`, payload).then(unwrap)
  },
  getCashboxOpeningContext(params = {}) {
    return apiService.get('/api/cashbox/opening-context', params).then((response) => response?.data?.data)
  }
}
